//import { Link } from 'react-router-dom'
import { Link } from "react-router-dom";
import { Breadcrumb } from "taltech-styleguide";
import useBreadcrumbs from "use-react-router-breadcrumbs";
import { observer } from "mobx-react";
import { modifiedRoutes } from "./dynamic.breadcrumbs";

/**
 * Function: isActive
 *
 * This function checks if the current pathname matches the provided pathname.
 *
 * @param {string} pathname - The pathname to check.
 * @returns {boolean} True if the current location pathname matches the provided pathname, otherwise false.
 */
const isActive = (pathname: string) =>
  // eslint-disable-next-line no-restricted-globals
  location.pathname === pathname;

/**
 * Functional Component: BreadcrumbsInner
 *
 * This component renders the breadcrumb navigation using the modified routes configuration.
 * It uses the `useBreadcrumbs` hook to generate breadcrumb items and marks the active breadcrumb.
 *
 * Returns:
 * @returns {JSX.Element} A JSX element containing the breadcrumb navigation.
 */
function BreadcrumbsInner() {
  const breadcrumbs = useBreadcrumbs(modifiedRoutes, {
    excludePaths: [
      "/components-db/data",
      "/components-db/data/space-functions/spaces",
      "/components-db/data/space-functions/parameters",
      "/components-db/components",
      "components-db/components/floors/types",
      "components-db/components/floors/parameters",
      "components-db/components/walls/types",
      "components-db/components/walls/parameters",
      "components-db/components/windows/types",
      "components-db/components/windows/parameters",
      "components-db/components/roofs/types",
      "components-db/components/roofs/parameters",
      "/components-db/presets",
    ],
  }).slice(1);
  return (
    <Breadcrumb>
      {breadcrumbs.map(({ match, breadcrumb }) => (
        <Breadcrumb.Item
          key={match.pathname}
          active={isActive(match.pathname)}
          linkAs={Link}
        >
          <Link to={match.pathname}>{breadcrumb}</Link>
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
}

export const Breadcrumbs = observer(BreadcrumbsInner);
